// 🔧 vendor_builder.js
// ✅ Purpose: Orchestrates the Vendor Engine build process
// ✅ Features:
// - Runs when the Vendors add-on is selected in Demo Builder
// - Coordinates vendor generation
// - Seeds vendor demo data through the repository layer
// - Updates DemoContext with created vendor data
// - Returns standardized execution results for Demo Report v2
// - Fully block-commented for clarity and future devs

import { generateVendors } from "./vendor_generator";
import { seedVendors } from "./vendor_seeder";
import { buildVendorReport } from "./vendor_report";

export const buildVendors = async ({
  demoContext,
} = {}) => {
  console.log("🏪 Vendor Builder started.");

  const vendorPlan = generateVendors({
    demoContext,
  });

  const vendorResults = await seedVendors({
    demoContext,
    vendorPlan,
  });

  demoContext.vendors = {
    vendors: vendorResults.vendors || [],
  };

  return buildVendorReport({
    vendorResults,
  });
};